module.exports = __webpack_public_path__ + "img/openchat.258b49b2.png";